export default "__VITE_ASSET__DWxdXeCc__"